<template>
<!-- ${style[$route.query.style]} -->
  <div id="wdc-app" :class="{'wdc-app': true, [theme]: theme}">
    <router-view
      v-if="excludeNavPage.includes($route.name)"
    ></router-view>
    <template v-else>
      <NAV v-if="!isDdy"/>
      <MHNAV v-else/>
      <div
        v-if="!isDdy"
        ref="main"
        class="main"
        :style="$route.name==='opHomepage'||$route.name==='serviceProviderList'||$route.name==='opcourseGoods'?'padding-top: 147px;background:#ffffff;':'padding-top:147px;'"
      >
        <router-view :key='key' />
      </div>
      <div
        v-else
        ref="main"
        class="main"
        :style="$route.name==='opcourseGoodsDetail'||$route.name==='opcourseGoods'?'padding-top: 30px;background:#ffffff;':'padding-top: 147px;'"
      >
        <router-view :key='key' />
      </div>
      <DDYFOOTER v-if="isCMS"/>
    </template>
    <!-- <el-backtop></el-backtop> -->
  </div>
</template>

<script>
import NAV from './view/head/crowd/module/jiazhengNav'
import MHNAV from './view/head/crowd/module/mhNav.vue'
import DDYFOOTER from './modules/dynamic/components/ddyFooter.vue'
export default {
  data () {
    return {
      excludeNavPage: ['login','register', 'error', 'video',  'teacherLive', 'studentSee', 'register-jz','forget','training_detail', 'testPaper','livePlayback','register-mz','personnel','screen','service-agreement','privacy'],
      isDdy:false,
      isCMS:false,
    };
  },
  computed:{
    theme(){
      return this.$store.state.theme
    },
    key() {
      return this.$route.name !== undefined ? this.$route.name + new Date() : this.$route + new Date()
    },
  },
  components: { NAV,MHNAV,DDYFOOTER },
  watch:{
    $route:{
        handler:function (val,oldVal) {
          console.log('route',val,oldVal)
          if(window.location.href.indexOf('/map/')!=-1&&window.location.href.indexOf('wdgxjz-pc')!=-1){
            this.isCMS = true;
          }else{
            this.isCMS = false;
          }
        },
        deep:true
      }
  },
  async created () {
    if(window.location.href.indexOf('wdgxjz-pc')!=-1){
      this.isDdy = true;
    }
    if(window.location.href.indexOf('/map/')!=-1&&window.location.href.indexOf('wdgxjz-pc')!=-1){
        this.isCMS = true;
      }else{
        this.isCMS = false;
      }
  },
  async mounted(){
  },
  methods: {

  },
};
</script>

<style lang="stylus">
/**一分栏  二分栏 选项卡  样式*/
div[data-comp-name="12-12"],div[data-comp-name="1-2"],div[data-comp-name="Tabs"]{
    width: 1200px;
    margin: 0 auto;
}
/* 选项卡tabs样式修改 */
.common-page {
    .el-tabs {
        .el-tabs__nav-wrap::after{
            display: none;
        }
        .el-tabs__nav-scroll {
            .el-tabs__nav {
                .el-tabs__active-bar {
                    display: none;
                }
            }
        }
    }
}
.backtop
  overflow-y scroll
.flex
  display flex
.lr-flex
  justify-content space-between
.el-message
  min-width 150px
.el-message.is-closable .el-message__content
  padding-right 36px
</style>
